import Home from "./pages/Home";
import Product from "./pages/Product";
import About from "./pages/other/About";
import Contact from "./pages/other/Contact";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import Cart from "./pages/other/Cart";
import NotFound from "./pages/other/NotFound";
import MyOrders from "./pages/dashboard/Orders";
import ProtectedRoute from "./wrappers/ProtectedRoute";
import Details from "./pages/dashboard/companyDetails/Details";
import OrderSuccess from "./pages/order/OrderSuccess";
import BlogNoSidebar from "./pages/blog/BlogNoSidebar";
import Expertise from "./pages/other/Expertise";
import Career from "./pages/other/Career";
import Media from "./pages/other/Media";
import BlogStandard from "./pages/blog/BlogStandard";
import BlogRightSidebar from "./pages/blog/BlogRightSidebar";
import BlogDetailsStandard from "./pages/blog/BlogDetailsStandard";
import Logout from "./pages/auth/Logout";
import Category from "./pages/category/Category";
import Collection from "./pages/category/collection/Collection";
import OrderDetail from "./pages/order/OrderDetail";
import TermsCondition from "./pages/footerPages/TermsCondition";
import OurPolicy from "./pages/footerPages/OurPolicy";
import PrivacyPolicy from "./pages/footerPages/PrivacyPolicy";
import ShippingPolicy from "./pages/footerPages/ShippingPolicy";
import ReturnPolicy from "./pages/footerPages/ReturnPolicy";
import CancellationPolicy from "./pages/footerPages/CancellationPolicy";
import Search from "./pages/Search";
import MyStock from "./pages/dashboard/myStock";
import MakingCharges from "./pages/dashboard/makingCharges";
import StoreLink from "./pages/dashboard/storeLink/StoreLink";
import MyStore from "./pages/dashboard/myStore/MyStore";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/product/:id", element: <ProtectedRoute element={<Product />} /> },
  { path: "/category/:id", element: <Category /> },
  { path: "/collection/:id", element: <Collection /> },
  { path: "/AboutUs", element: <About /> },
  { path: "/ContactUs", element: <Contact /> },
  { path: "/search", element: <Search /> },
  { path: "/orders", element: <ProtectedRoute element={<MyOrders />} /> },
  { path: "/my-stock", element: <ProtectedRoute element={<MyStock />} /> },
  { path: "/store-link", element: <ProtectedRoute element={<StoreLink />} /> },
  { path: "/my-store", element: <ProtectedRoute element={<MyStore />} /> },
  { path: "/details", element: <ProtectedRoute element={<Details />} /> },
  {
    path: "/order-success",
    element: <ProtectedRoute element={<OrderSuccess />} />,
  },
  { path: "/order/:id", element: <ProtectedRoute element={<OrderDetail />} /> },
  { path: "/logout", element: <ProtectedRoute element={<Logout />} /> },
  {
    path: "/making-charges",
    element: <ProtectedRoute element={<MakingCharges />} />,
  },
  { path: "/register", element: <Register /> },
  { path: "/login", element: <Login /> },
  { path: "/cart", element: <Cart /> },
  { path: "/cart/:id", element: <Cart /> },
  { path: "/terms-condition", element: <TermsCondition /> },
  { path: "/our-policy", element: <OurPolicy /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/shipping-policy", element: <ShippingPolicy /> },
  { path: "/return-policy", element: <ReturnPolicy /> },
  { path: "/cancellation-policy", element: <CancellationPolicy /> },
  { path: "/blog-no-sidebar", element: <BlogNoSidebar /> },
  { path: "/blog", element: <BlogNoSidebar /> },
  { path: "/blog-standard", element: <BlogStandard /> },
  { path: "/blog-right-sidebar", element: <BlogRightSidebar /> },
  { path: "/blog-details-standard", element: <BlogDetailsStandard /> },
  { path: "/career", element: <Career /> },
  { path: "/expertise", element: <Expertise /> },
  { path: "/media", element: <Media /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
